import React from 'react'

const DEFAULT_DELAY_BEFORE_LAUNCH = 0
const STATUS_WAITING = 'waiting'
const STATUS_READY = 'ready'

export default class DelayComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      status: STATUS_WAITING
    }
  }

  componentDidMount() {
    this.timeout = setTimeout(this.ready, this.props.delay || DEFAULT_DELAY_BEFORE_LAUNCH)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  ready = () => {
    this.setState({ status: STATUS_READY })
  }

  render() {
    if (this.state.status !== STATUS_READY) return null
    return this.props.children
  }
}
